module.exports = __webpack_public_path__ + "img/Bathroom.e83b1928.jpg";